import Analytics from "./util/Analytics";
import Context from "shared/util/Context";
import { mapDraftToConnectionLayer, isStandalonePage } from "apps/messenger/util/helpers";
import { LikedVia } from "apps/messenger/components/Connections/constants";

import { SEND_MESSAGE_SUCCESS } from "ducks/global_messaging";

export default function globalMessaging(state, action) {
	switch (action.type) {
		case SEND_MESSAGE_SUCCESS: {
			const payload = action.payload;
			const conversation = state.conversationData[payload.userid] || {};

			const { likedVia } = mapDraftToConnectionLayer({ draft: payload.draft });
			const profileComment = likedVia === LikedVia.GLOBAL
				? "none"
				: likedVia.toLowerCase();

			// mParticle Analytics
			Analytics.logUIEvent(Analytics.eventNames.sentMessage, {
				data: {
					"message id": payload.msgid,
					"character count (no spaces)": payload.messageText.replace(/\s/gi, "").length,
					"match %": payload.matchPercentage,
					nway: conversation.nway,
					"is intro": conversation.nway === 1 ? "yes" : "no",
					"sent in pop-out": isStandalonePage ? "yes" : "no",
					"profile comment": profileComment,
					"target user id": payload.userid,
					userid: Context.get("userid"),
				},
			});

			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/global_messaging.js